import * as React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import './YourPolicy.css'
import { HOME } from '../../routes/routes';

class WhyChooseKP extends React.Component<any, any> {
    public render() {
        return (
            <div className="Rectangle">
                <div className="row red-box">
                    <div className="col-12">
                        <h2 className="Insurance-made-easy">Why choose <br />King Price</h2>
                        <div className="li-list">
                            <ul className="Get-instant-cover-fo">
                                <li>Car insurance premiums that decrease monthly.</li>
                                <li>Up to 20% off when you insure 2+ cars.</li>
                                {this.props.profile.countryId != 157 && <li>Pay-as-you-drive chilli comprehensive car cover
                                    from R299 a month.</li>}
                                <li>The freedom to choose your own excess.</li>
                                {this.props.profile.countryId != 157 && <li>R1 cover for high-value items like golf clubs and bicycles.</li>}
                                <li>This easy-to-use insurance portal!</li>
                            </ul>
                        </div>
                        <div className="mb-5">
                            <h3 className="Not-a-member-yet">{this.props.profile.countryId != 157 ? "Already a client?" : "Already registered?"}</h3>
                            <Link to={HOME} className="btn btn-outline-white btn-lg">Log in now</Link>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {}
}
export default connect(mapStateToProps, mapDispatchToProps)(WhyChooseKP);